import { render, staticRenderFns } from "./ModuleText.vue?vue&type=template&id=f7b40408&scoped=true&"
import script from "./ModuleText.vue?vue&type=script&lang=js&"
export * from "./ModuleText.vue?vue&type=script&lang=js&"
import style0 from "./ModuleText.vue?vue&type=style&index=0&id=f7b40408&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b40408",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Animation: require('/vercel/path0/components/Animation.vue').default})
